import {
  getClientEnv
} from '../../../utils/common'

export const DEFAULT_ERROR_MSG = '服务器开小差，请稍后重试'

/**
 * 跳到商城下订单带上的渠道号，标识充电VIP业务
 */
export const MALL_ENTRY = 300054

/**
 * 商城订单详情页，访问时需要拼接bizId，根据当前环境返回
 */
export const MALL_DETAIL_PAGE_URL = {
  'test': 'http://pmall.test.xiaopeng.local/order/detail/',
  'deploy': 'https://pmall.cs-pre.xiaopeng.com/order/detail/',
  'product': 'https://mall.xiaopeng.com/order/detail/'
}
export const curEnvMallDetailPageUrl = MALL_DETAIL_PAGE_URL[getClientEnv()]